import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollReset() {
  const { pathname } = useLocation();

  useEffect(() => {
    const resetScrollBlackList = [
      '/home.*',
    ];

    if (!resetScrollBlackList.find((bl) => pathname.match(new RegExp(bl)))) {
      window.scrollTo(0, 0);
    }
  }, [pathname,]);

  return null;
}
